export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const ALL_DESCRIPTIONS = [
  { icon: '01d.png', description: 'clear sky' },
  { icon: '02d.png', description: 'few clouds' },
  { icon: '03d.png', description: 'scattered clouds' },
  { icon: '04d.png', description: 'broken clouds' },
  { icon: '04d.png', description: 'overcast clouds' },
  { icon: '09d.png', description: 'shower rain' },
  { icon: '09d.png', description: 'light intensity drizzle' },
  { icon: '09d.png', description: 'drizzle' },
  { icon: '09d.png', description: 'heavy intensity drizzle' },
  { icon: '09d.png', description: 'light intensity drizzle rain' },
  { icon: '09d.png', description: 'drizzle rain' },
  { icon: '09d.png', description: 'heavy intensity drizzle rain' },
  { icon: '09d.png', description: 'shower rain and drizzle' },
  { icon: '09d.png', description: 'heavy shower rain and drizzle' },
  { icon: '09d.png', description: 'shower drizzle' },
  { icon: '09d.png', description: 'light intensity shower rain' },
  { icon: '09d.png', description: 'shower rain' },
  { icon: '09d.png', description: 'heavy intensity shower rain' },
  { icon: '09d.png', description: 'ragged shower rain' },
  { icon: '10d.png', description: 'rain' },
  { icon: '10d.png', description: 'light rain' },
  { icon: '10d.png', description: 'moderate rain' },
  { icon: '10d.png', description: 'heavy intensity rain' },
  { icon: '10d.png', description: 'very heavy rain' },
  { icon: '10d.png', description: 'extreme rain' },
  { icon: '11d.png', description: 'thunderstorm' },
  { icon: '11d.png', description: 'thunderstorm with light rain' },
  { icon: '11d.png', description: 'thunderstorm with rain' },
  { icon: '11d.png', description: 'thunderstorm with heavy rain' },
  { icon: '11d.png', description: 'light thunderstorm' },
  { icon: '11d.png', description: 'heavy thunderstorm' },
  { icon: '11d.png', description: 'ragged thunderstorm' },
  { icon: '11d.png', description: 'thunderstorm with light drizzle' },
  { icon: '11d.png', description: 'thunderstorm with drizzle' },
  { icon: '11d.png', description: 'thunderstorm with heavy drizzle' },
  { icon: '13d.png', description: 'snow' },
  { icon: '13d.png', description: 'freezing rain' },
  { icon: '13d.png', description: 'light snow' },
  { icon: '13d.png', description: 'Snow' },
  { icon: '13d.png', description: 'Heavy snow' },
  { icon: '13d.png', description: 'Sleet' },
  { icon: '13d.png', description: 'Light shower sleet' },
  { icon: '13d.png', description: 'Light rain and snow' },
  { icon: '13d.png', description: 'Rain and snow' },
  { icon: '13d.png', description: 'Light shower snow' },
  { icon: '13d.png', description: 'Shower snow' },
  { icon: '13d.png', description: 'Heavy shower snow' },
  { icon: '50d.png', description: 'mist' },
  { icon: '50d.png', description: 'Smoke' },
  { icon: '50d.png', description: 'Haze' },
  { icon: '50d.png', description: 'sand/ dust whirls' },
  { icon: '50d.png', description: 'fog' },
  { icon: '50d.png', description: 'sand' },
  { icon: '50d.png', description: 'dust' },
  { icon: '50d.png', description: 'volcanic ash' },
  { icon: '50d.png', description: 'squalls' },
  { icon: '50d.png', description: 'tornado' },
];
